module.exports = __webpack_public_path__ + "img/br2.b83062a8.jpg";